// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"ebd7b003","599":"b8d1f48e"}[chunkId] + ".chunk.css";
};